module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_2"
    }
  }, [_c('span', [_vm._v("The Way Beyond")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_vm._v("by Eliana West")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('i', [_vm._v("When she finds out his secret, will he lose her for good?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jacob Winters has a secret: he’s come to Colton undercover as an FBI handler. He didn’t plan to stay, but the small town has charmed him with a sense of community that he hasn’t felt in a long time. And his attraction to the beautiful Mae Colton complicates things even more. Jacob doesn’t do relationships—he won’t risk making memories he might regret.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mae Colton loves her little town of Colton, Mississippi, and doesn’t want to leave. In fact, instead of moving on to bigger things—namely a political career in DC like she’d planned—she wants to run for a second term as mayor of Colton. But not everyone in town supports this choice, including the commitment-phobic Jacob Winters.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mae is ready to make their secret relationship official and go public, but that would break Jacob’s one rule. When a threat against Mae’s life forces him to admit the truth of his feelings, he has to race to save the woman he loves before it’s too late.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6328bbc1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0002.vue
// module id = 60
// module chunks = 0